/* eslint-disable react/no-array-index-key */

import React, { useEffect } from 'react';
import withValidations from 'lib/hocs/withValidations';
import ConfigStore from 'lib/stores/configStore';
import { handleChange } from 'lib/stores/formStore';
import { formatIdFromName } from 'lib/utility';

import FormLabel from './FormLabel';

const FormTimePicker = ({ name, label, value, id, defaultTime, required, ariaLabel, fluid }) => {
  const { timeOptions } = ConfigStore.useState(state => state);

  useEffect(() => {
    if (!defaultTime) return;
    if (value) return;

    handleChange(defaultTime, name);
  }, [defaultTime]);

  return (
    <div className="mb-3">
      {label && (
        <FormLabel id={id || formatIdFromName(name)} label={label || name} required={required} />
      )}
      <select
        name={name}
        value={value}
        onChange={handleChange}
        id={id || formatIdFromName(name)}
        data-testid={formatIdFromName(name)}
        aria-label={ariaLabel || 'Time'}
        className={`form-control ${fluid ? 'w-100' : 'w-25'}`}
      >
        <option value="">Select a time</option>
        {timeOptions.map(([val, timeName], i) => (
          <option key={i} value={val}>
            {timeName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default withValidations({ required: true })(FormTimePicker);
